import { getBigger } from '../Table'
import { getWidthOfText } from '@/helpers/strings'

export default {
  setIndex: function(index) {
    this.index = index
    this.triggerUpdate()
  },
  getMaxWidth: function() {
    return this.maxWidth[this.index]
  },
  getDataLengths: function(columnIndex) {
    return this.dataLengths[this.index][columnIndex]
  },
  getAllData: function() {
    this.parsedData.forEach((spreadsheet, index) => {
      spreadsheet.width = this.maxWidth[index]
    })

    return this.parsedData
  },
  getIndex: function(spreadsheet, row, column) {
    return `${spreadsheet}-${row}-${column}`
  },
  getCurrentIndex: function(row, column) {
    return this.getIndex(this.index, row, column)
  },
  updateDataLocations: function() {
    this.getCurrentData().map((datum, index) => {
      let row = Math.floor(index / this.getMaxWidth())
      let column = index % this.getMaxWidth()
      datum.data.location = this.getCurrentIndex(row, column)
    })
  },
  getContextName: function(location) {
    let split = location.split('-')
    let name = split[0]
    return name
  },
  initializeMaxWidth: function(spreadsheets) {
    const maxValue = (accumulator, currentValue) => accumulator > currentValue ? accumulator : currentValue

    let maxWidth = []

    spreadsheets.forEach(spreadsheet => {
      let dataLengths = spreadsheet.data.map(row => row.length)
      maxWidth.push(dataLengths.reduce(maxValue))
    })

    this.maxWidth = maxWidth
  },
  initializeDataLengths: function(spreadsheets) {
    let result = []

    spreadsheets.forEach((spreadsheet, index) => {
      let spreadsheetMaxLength = []
      let numRows = spreadsheet.data.length
      let data = spreadsheet.data
      let currLength = 0
      this.columnHeaders[index].forEach(column => {
        let minLength = 10
        let maxLength = 0
        for (let row = 0; row < numRows; row++) {
          let datum = data[row][column.data.value]
          currLength = getWidthOfText(datum.value, '16px') + 30
          maxLength = getBigger(currLength, maxLength)
        }

        maxLength = getBigger(minLength, maxLength)
        spreadsheetMaxLength.push(maxLength)
      })

      result.push(spreadsheetMaxLength)
    })

    this.dataLengths = result
  },
  getCurrentData: function() {
    return this.parsedData[this.index].data
  },
  setCurrentData: function(data) {
    this.parsedData[this.index].data = data
    this.triggerUpdate()
  },
  getColumnLength: function(index) {
    if (index < 0)
      index = 0

    const relevantDataLengths = this.dataLengths[this.index].slice(0, index)

    if (relevantDataLengths.length == 0) {
      return 0
    }

    const reducer = (accumulator, currentValue) => accumulator + currentValue
    return relevantDataLengths.reduce(reducer)
  },
  getRowIndex: function(location) {
    let split = location.split('-')
    let name = split[0]
    let index = null

    if (name == 'cell') {
      index = split[2]
    } else if (name == 'rowHeader') {
      index = split[1]
    }

    return parseInt(index)
  },
  getLocationColumn: (location) => location ? location.split('-')[2] : null,
  getLocationRow: (location) => location ? location.split('-')[1] : null,
  getLocationIndex: (location) => location ? location.split('-')[0] : null,
}